// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2fMnw","list":"BalanceDue_list__1_Sk4","listRow":"BalanceDue_listRow__3iHBB","total":"BalanceDue_total__2RT57"};